import React from 'react';
import ComparisonPage from './ComparisonPage';

export default function VsSwimTopia() {
    return <ComparisonPage slug="swimtopia" />;
}
